import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useMenuStore } from "@/store";
import { Button } from "../common";
import MobileMenu from "./MobileMenu";

const Header = () => {
  const { isMenuOpen, setMenuOpen, toggleMenu } = useMenuStore();
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  useEffect(() => {
    document.documentElement.classList.add("js-enabled");
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      if (!target.closest("[data-dropdown]")) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleDropdownClick = (dropdownId: string) => {
    setActiveDropdown(activeDropdown === dropdownId ? null : dropdownId);
  };

  const handleMenuToggle = () => {
    toggleMenu();
    document.body.style.overflow = !isMenuOpen ? "hidden" : "";
  };

  const closeDropdown = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
    if (!isMenuOpen) {
      document.body.style.overflow = "";
    }
  }, [isMenuOpen]);

  return (
    <div
      className="fixed top-0 left-0 w-full py-8 z-[1000]"
      style={{ backgroundColor: "rgb(255, 255, 255)" }}
    >
      <header className="flex items-center justify-between px-8 mx-auto  max-w-container w-full px-12 wide:px-0">
        {/* 왼쪽: 로고 + 메인 메뉴 */}
        <div className="flex items-center gap-14">
          <Link to="/" className="flex-shrink-0">
            <img src="/img/gnb_logo.png" alt="STANDARD NETWORKS 로고" />
          </Link>
        </div>

        {/* 오른쪽: 문의 드롭다운 + 로그인 */}
        <div className="items-center hidden gap-10 lg:flex">
          {/* 데스크톱 메뉴 */}
          <ul className="items-center hidden gap-10 lg:flex">
            <li>
              <Link
                to="/about/vision"
                className="text-[1.6rem] font-medium text-gray-900 hover:text-navy transition-colors hover:text-std-blue"
              >
                회사 소개
              </Link>
            </li>
            <li>
              <Link
                to="/service-provide/voucher-aicc"
                className="text-[1.6rem] font-medium text-gray-900 hover:text-navy transition-colors hover:text-std-blue"
              >
                서비스 소개
              </Link>
            </li>
            {/* <li>
              <Link
                to="/business/messaging"
                className="text-[1.6rem] font-medium text-gray-700 hover:text-navy transition-colors"
              >
                사업 분야
              </Link>
            </li> */}
            {/* <li className="relative" data-dropdown>
              <button
                type="button"
                className="flex items-center gap-1 text-[1.6rem] font-medium text-gray-700 hover:text-navy transition-colors"
                onClick={() => handleDropdownClick("service")}
              >
                서비스 도입
                <span className="material-icons-round text-[1.8rem]">keyboard_arrow_down</span>
              </button>
              <div
                className={`absolute top-full left-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-100 py-2 min-w-[180px] transition-all ${
                  activeDropdown === "service" ? "opacity-100 visible" : "opacity-0 invisible"
                }`}
              >
                <Link
                  to="/service/messaging"
                  className="flex items-center gap-3 px-4 py-3 text-[1.5rem] text-gray-700 hover:bg-gray-50 hover:text-navy"
                  onClick={closeDropdown}
                >
                  <span className="material-icons-round text-[2rem] text-navy">message</span>
                  메시징서비스
                </Link>
                <Link
                  to="/service/aicc"
                  className="flex items-center gap-3 px-4 py-3 text-[1.5rem] text-gray-700 hover:bg-gray-50 hover:text-navy"
                  onClick={closeDropdown}
                >
                  <span className="material-icons-round text-[2rem] text-navy">support_agent</span>
                  문자콜센터
                </Link>
              </div>
            </li> */}
          </ul>
          <div className="flex gap-4">
            <div className="relative" data-dropdown>
              <Link to="/voc/submit">
                <Button
                  size="sm"
                  variant="outline"
                  className="flex items-center gap-1 border px-[2rem] rounded-md border-gray-400 text-[1.6rem] font-medium text-gray-700 hover:text-navy transition-colors"
                >
                  문의
                </Button>
              </Link>
            </div>

            <a
              className="px-[2.5rem] py-2.5 bg-navy text-white text-[1.6rem] font-medium rounded-md hover:opacity-90 transition-opacity"
              href="https://customer.std-ums.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              로그인
            </a>
          </div>
        </div>

        {/* 모바일 메뉴 토글 */}
        <button
          type="button"
          className="relative flex items-center justify-center w-10 h-10 lg:hidden"
          aria-expanded={isMenuOpen}
          onClick={handleMenuToggle}
        >
          <span className="relative flex items-center justify-center w-6 h-6">
            {/* top */}
            <span
              className={`absolute w-6 h-[2px] bg-gray-700 transition-all duration-300 origin-center
                          ${isMenuOpen ? "rotate-45" : "-translate-y-2"}
                        `}
            />

            {/* middle */}
            <span
              className={`absolute w-6 h-[2px] bg-gray-700 transition-all duration-300
                          ${isMenuOpen ? "opacity-0 scale-0" : "opacity-100 scale-100"}
                        `}
            />

            {/* bottom */}
            <span
              className={`absolute w-6 h-[2px] bg-gray-700 transition-all duration-300 origin-center
                          ${isMenuOpen ? "-rotate-45" : "translate-y-2"}
                        `}
            />
          </span>
        </button>

        {/* 모바일 메뉴 */}
        <MobileMenu isOpen={isMenuOpen} onClose={() => setMenuOpen(false)} />
      </header>
    </div>
  );
};

export default Header;
